import { useState, useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarIcons from "./SidebarIcons";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import dashlogo from "../assets/img/dashbarlogo.png";
import { BOOKING_HISTORY, DOOR_INSPECTION_API } from "../api/apiPath";
import http from "../api/server";
import Iframe from "react-iframe";
import Toaster from "./common/Toaster";

import StatusPill from "./common/StatusPill";

export default function BookingHistory() {
  const [open, setOpen] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);
  const { inspectionMasterId, propertyMasterId } = useParams();
  const [hideSidebar, setHideSidebar] = useState(false);
  const { userObj } = useSelector((state) => state.user);

  const [showLoader, setShowLoader] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);

  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState({});

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const handleDownloadClick = async (propertyMasterId) => {
    setShowLoader(true);
    try {
      const response = await http.get(DOOR_INSPECTION_API, {
        params: {
          propertyId: propertyMasterId,
        },
        responseType: "blob",
      });

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      setPdfUrl(fileURL);
      if (isMobile) {
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = `${propertyMasterId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setShowPdfModal(true);
      }
    } catch (err) {
      console.error("Error while downloading ", err);
      console.log(
        "Something went wrong while downloading, please try again after sometime"
      );
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString:
          err.message ||
          "Something went wrong while downloading, please try again after sometime",
      });
    } finally {
      setLoading(false);
    }
  };

  //  ALL possible inspection statuses (always visible)
  const ALL_STATUSES = [
    "Property Onboarded",
    "Inspection Created",
    "Inspection Scheduled",
    "Inspection Started",
    "Submitted For Approval",
    "Approved",
  ];

  useEffect(() => {
    const fetchBookingHistory = async () => {
      try {
        setLoading(true);

        const { data } = await http.get(BOOKING_HISTORY, {
          params: {
            clientId: userObj?.clientId,
            inspectionReferenceNumber: inspectionMasterId,
          },
        });

        // const getIcon = (eventType) => {
        //   switch (eventType) {
        //     case "Inspection Started":
        //       return "fa-solid fa-circle-check";
        //     case "Inspection Created":
        //       return "fa-solid fa-circle-check";
        //     case "Property Onboarded":
        //       return "fa-solid fa-circle-check";
        //     case "Resubmission date":
        //       return "fa-solid fa-circle-check";
        //     case "Submitted For Approval":
        //       return "fa-solid fa-circle-check";
        //     case "Approved":
        //       return "fa-solid fa-circle-check";
        //     case "Rejected":
        //       return "fa-solid fa-xmark";
        //     default:
        //       return "fa-solid fa-circle-check";
        //   }
        // };

        // const eventData = data?.events || [];

        const summaryData = data?.summary;
        setSummary(summaryData);

        // const formattedSteps = eventData.map((item) => ({
        //   icon: getIcon(item.eventType || item.status),
        //   title: item.eventType || item.status || item.title,
        //   date: item.eventDate || item.actionDate,
        //   boxText: item.performedBy
        //     ? `${item.eventType} by - ${item.performedBy}`
        //     : item.comments || item.boxText || item.status || "",
        //   highlight: item.highlight || false,
        // }));
        // setSteps(formattedSteps || []);
        const eventData = data?.events || [];

        // convert API events into lookup object
        const eventMap = eventData.reduce((acc, curr) => {
          acc[curr.eventType] = curr;
          return acc;
        }, {});

        // build steps from MASTER status list
        const buildSteps = ALL_STATUSES.map((status) => {
          const apiEvent = eventMap[status];

          return {
            title: status,
            completed: !!apiEvent,
            icon: apiEvent
              ? "fa-solid fa-circle-check"
              : "fa-regular fa-circle",
            date: apiEvent?.eventDate || "",
            performedBy: apiEvent?.performedBy || "",
            description: apiEvent?.comments || apiEvent?.description || "",
            boxText: apiEvent
              ? `${status} by - ${apiEvent.performedBy}`
              : status,
          };
        });

        // Find the last completed index (last API status)
        const lastCompletedIndex = buildSteps.reduce(
          (lastIndex, step, index) => (step.completed ? index : lastIndex),
          -1
        );

        // The status right after the last API status gets the dark dot (no checkmark)
        const nextStatusIndex = lastCompletedIndex + 1;

        setSteps(
          buildSteps.map((step, index) => ({
            ...step,
            isActiveBar: index <= lastCompletedIndex, // Dark bar only till last API status (bar after dark dot will be light)
            isCurrent: index === nextStatusIndex, // Next status after last API status gets dark dot
            isPending: index > nextStatusIndex, // Pending steps after the next status
          }))
        );
      } catch (err) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: err.message || "Unknown error occurred",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchBookingHistory();
  }, [userObj?.clientId, inspectionMasterId]);

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />

      {userObj && (
        <div className="dashboard_body_main vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={closeButton}
          />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}

          <div className="d-flex dashboard_body flex-column py-1  w-100 mt-2">
            <div className="dashboard_header">
              <div>
                <h2 className="mb-0">Inspection History</h2>
                <p className="header-description mb-0">
                  Track the complete timeline of your site inspection
                </p>
                <div className="download-container">
                  {showLoader ? (
                    <div className="loader"></div>
                  ) : (
                    <button
                      className="btn btn-dark fw-semibold"
                      onClick={() => {
                        handleDownloadClick(propertyMasterId);
                      }}
                      title="Download Report"
                    >
                      <i className="fa fa-download me-2"></i> Download Report
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div
              className="card mt-4 p-3 rounded-4 mb-4 orange-box d-flex gap-3 flex-row align-items-center justify-content-between"
              style={{ height: "9.5rem" }}
            >
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-evenly text-center py-4">
                  <div>
                    <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                      {summary?.totalDoors}
                    </h1>
                    <p className="fw-semibold mb-0">Total Doors</p>
                  </div>
                  <div className="col-6 col-sm-4 col-lg-2 mb-1">
                    <img src={dashlogo} alt="Inspector" height="100" />
                  </div>
                  <div>
                    <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                      {summary?.totalCriticalIssues}
                    </h1>
                    <p className="fw-semibold mb-0">Total Critical Issues</p>
                  </div>
                  <div>
                    <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                      {summary?.totalNonCompliantIssues}
                    </h1>
                    <p className="fw-semibold mb-0">
                      Total Non-Compliant Issues
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="resident-card mb-3">
              <div className=" flex-sm-row align-items-center ">
                <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h5 className="justifyStart fw-semibold mb-0 ">
                      {summary?.propertyName || "Property Name"}
                    </h5>

                    <p className="justifyCenter mb-0 mt-1">
                     <StatusPill status={summary?.inspectionStatus || ""} />
                    </p>
                  </div>

                  <p className="justifyStart text mb-0 mt-1">
                    {summary?.propertyLocation}
                  </p>

                  <div className="d-flex justify-content-between align-items-center w-100 mt-4 mb-4 text-black">
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: "#525254" }}>
                        Inspection Reference No :
                      </span>
                      <span>{inspectionMasterId || ""}</span>
                    </div>

                    <p className="d-flex align-items-center mb-0 gap-2">
                      <span style={{ color: "#525254" }}>
                        Inspection Managed By :
                      </span>
                      <span>{summary?.inspectionManagedBy}</span>
                    </p>
                  </div>
                </div>
                <div></div>
              </div>
            </div>

            <div className="resident-card mb-3">
              <div className=" flex-sm-row align-items-center ">
                <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                  <div className="step-header" onClick={() => setOpen(!open)}>
                    <p className="fw-semibold">{steps[0]?.title}</p>

                    <i
                      className={`bi ${
                        open ? "bi-chevron-up" : "bi-chevron-down"
                      }`}
                    ></i>
                  </div>
                  <div className="text-start">
                    <p className="text"> {steps[0]?.date}</p>
                  </div>
                  {open && (
                    <div className="step-details">
                      <p className="text">
                        {" "}
                        Property was successfully added to the system. All
                        initial information was verified and confirmed.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="resident-card mb-3">
              <div className=" flex-sm-row align-items-center ">
                <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                  <p className="text-start">
                    <b>Inspection Timeline</b>
                  </p>
                  <div className="bh-timeline">
                    {loading ? (
                      <p>Loading timeline...</p>
                    ) : steps.length > 0 ? (
                      steps.map((step, index) => (
                        <div className="bh-timeline-item-row" key={index}>
                          {/* LEFT SIDE: Progress bar + icon */}
                          <div className="bh-timeline-left">
                            {/* Vertical progress bar */}
                            {index < steps.length - 1 && (
                              <div
                                className={`bh-timeline-bar ${
                                  step.isActiveBar ? "bh-bar-active" : "bh-bar-inactive"
                                }`}
                              ></div>
                            )}
                            
                            {/* Icon/Node */}
                            <div
                              className={`bh-timeline-icon ${
                                step.isCurrent
                                  ? "bh-icon-current"
                                  : step.completed
                                  ? "bh-icon-completed"
                                  : "bh-icon-pending"
                              }`}
                            >
                              {step.isCurrent ? (
                                /* Status right after last API status - small dark dot in center, no checkmark */
                                <div className="bh-current-dot"></div>
                              ) : step.completed ? (
                                /* All completed API statuses - dark dot with checkmark */
                                <i className="fa-solid fa-check" style={{ fontSize: "10px", color: "#fff" }}></i>
                              ) : null}
                            </div>
                          </div>

                          {/* RIGHT SIDE: Event card */}
                          <div
                            className="bh-inspection-box text-start"
                            onClick={() =>
                              setOpenIndex(openIndex === index ? null : index)
                            }
                          >
                            <div className="bh-timeline-info">
                              <div className="d-flex align-items-center justify-content-between mb-0">
                                <div>
                                  <div className="bh-inspection-title-after fw-semibold mb-1">
                                    {step.title}
                                    <span> - {step.performedBy}</span>
                                  </div>
                                  {/* {step.performedBy && (
                                    <div className="text mb-1" style={{ fontSize: "14px" }}>
                                      {step.performedBy}
                                    </div>
                                  )} */}
                                </div>
                                <i
                                  className={`bi ${
                                    openIndex === index
                                      ? "bi-chevron-up"
                                      : "bi-chevron-down"
                                  }`}
                                  style={{ fontSize: "18px", color: "#737373" }}
                                ></i>
                              </div>

                              <div className="bh-inspection-date text mb-2">
                                {step.date  || (step.isPending ? "Pending • TBD" : "")}
                              </div>

                              {openIndex === index && step.description && (
                                <div className="bh-step-details mt-2">
                                  <p className="text">
                                    {step.description}
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No booking history found.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      )}
      {showPdfModal && pdfUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              maxHeight: "80vh",
              backgroundColor: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 className="modal-title mb-0">PDF Preview</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowPdfModal(false);
                  setPdfUrl(null);
                }}
              ></button>
            </div>
            <div style={{ height: "90vh", padding: 0 }}>
              <Iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title="PDF Preview"
                style={{
                  border: "none",
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
              ></Iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
